module.exports = "/_next/static/images/slide3-e084a6785b76dafeb6a5d8212cf4d814.webp";